import React, { useEffect, useRef, useCallback } from 'react';
import {
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import Contens from './Contens';
import { useGlobalContext } from '../GlobalContext';

const ProtectedLayout = () => {
  const { api, menuakses, isReady, clearUserData } = useGlobalContext();
  const location = useLocation();
  const navigate = useNavigate();
  const timerRef = useRef(null);  
  //const currentMatch = matches[matches.length - 1];

  //const title = currentMatch?.handle?.title || 'Dashboard';

  /*const resetTimer = async useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      await api.post('/users/logout');
      clearUserData();
      //navigate('/logout');
      navigate('/login', { replace: true });
    }, 300000); // 5 minutes
  }, [clearUserData, navigate]);*/

  const resetTimer = useCallback(() => {
    // Hapus timer sebelumnya
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    console.log('Reset timer aktivitas pengguna. Timer akan direset selama 5 menit.');

    // Buat timer baru: 5 menit
    timerRef.current = setTimeout(async () => {
      try {
        // Logout ke backend
        await api.post('api/users/logout');
      } catch (error) {
        console.error('Auto logout error:', error);
      } finally {
        // Bersihkan data client lainnya jika ada
        clearUserData();

        // Arahkan ke login
        navigate('/login', { replace: true });
      }
    }, 5 * 60 * 1000);
  }, [api, clearUserData, navigate]);

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    const handleActivity = () => resetTimer();

    events.forEach(event => window.addEventListener(event, handleActivity));
    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, handleActivity));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);

  if (!isReady) {
    if (!localStorage.getItem('pengguna')) {
      return <Navigate to="/login" replace />;
    }
    return (
      <div className="wrapper" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6f9' }}>
        <div>Memuat...</div>
      </div>
    );
  }

  const normalize = (url) => {
    if (!url) return '';

    const cleanUrl = String(url).trim().split('#')[0].split('?')[0];
    if (!cleanUrl) return '';

    const withLeadingSlash = cleanUrl.startsWith('/') ? cleanUrl : `/${cleanUrl}`;
    const normalizedUrl = withLeadingSlash.replace(/\/+$/, '').toLowerCase() || '/';
    const routeAliases = {
      '/daftarsimpharian': '/daftarsimpmanasuka',
      '/daftarsimpsaham': '/daftarsimpsaham',
    };

    return routeAliases[normalizedUrl] || normalizedUrl;
  };

  const currentPath = normalize(location.pathname);
  const allowedUrls = (menuakses || []).map(item => normalize(item.url));

  const whitelist = [
    '/dashboard',
    '/',
  ];

  const isAllowed =
  allowedUrls.includes(currentPath) ||
  whitelist.includes(currentPath);

  if (!isAllowed) {
    return <Navigate to="/login" replace />;
  }

  // ==============================
  // TITLE HALAMAN
  // ==============================
  const pageTitles = {
    '/dashboard': 'Dashboard',
    '/dashboard2': 'Dashboard Home',
    '/dashboard/piutang': 'Dashboard Piutang',
    '/dashboard/simpanan': 'Dashboard Simpanan',
    '/piutangnonlunas': 'Piutang Non Lunas',

    '/role': 'Role',
    '/rolehalaman': 'Role Halaman',
    '/daftaruser': 'Daftar User',
    '/daftaranggota': 'Daftar Anggota',
    '/daftarunitkerja': 'Daftar Unit Kerja',
    '/settingsimpanan': 'Setting Simpanan',
    '/setjasapinjaman': 'Setting Jasa Pinjaman',
    '/setjasamanasuka': 'Setting Jasa Manasuka',
    '/perkiraan': 'Perkiraan',
    '/potsimpmanasuka': 'Potongan Simpanan Manasuka',

    '/simpanangsurusp1': 'Simpanan Angsuran USP',
    '/simpanangsurusp2': 'Simpanan Angsuran Umum',
    '/transaksimanasuka': 'Transaksi Manasuka',
    '/transaksihariraya': 'Transaksi Hari Raya',
    '/transaksirealisasi': 'Transaksi Realisasi',

    '/laporanharian1': 'Laporan Harian USP',
    '/laporanharianmanasuka': 'Laporan Harian Manasuka',
    '/laporanharianhariraya': 'Laporan Harian Hari Raya',
    '/laporanvoucherbelanja': 'Laporan Voucher Belanja',
    '/laporanharianangsuran': 'Laporan Harian Angsuran',
    '/laporanharianangsuran2': 'Laporan Harian Angsuran 2',

    '/laporanmutasisimpananusp': 'Mutasi Simpanan USP',
    '/laporanmutasisimpmanasuka': 'Mutasi Simpanan Manasuka',
    '/laporanmutasisimphariraya': 'Mutasi Simpanan Hari Raya',
    '/laporanmutasivoucher': 'Mutasi Voucher',
    '/laporanmutasiangsuran': 'Mutasi Angsuran',
    '/mutasipotongan': 'Mutasi Potongan',
    '/mutasitunggakan': 'Mutasi Tunggakan',
    '/mutasirealisasi': 'Mutasi Realisasi',
    '/realisasipinjaman': 'Realisasi Pinjaman',

    '/prosesmanasuka': 'Proses Manasuka',
    '/proseshariraya': 'Proses Hari Raya',
    '/jurnal': 'Entri Jurnal',
    '/laporanjurnal': 'Laporan Jurnal',
    '/lapbukubesar': 'Laporan Buku Besar',
    '/rugilaba': 'Rugi Laba',
    '/potongan': 'Potongan',
    '/daftarangsuran': 'Daftar Angsuran',
    '/daftarsimpmanasuka': 'Daftar Simpanan Manasuka',
    '/daftarsimpsaham': 'Daftar Simpanan Saham',
    '/tutupbulan': 'Tutup Bulan',
    '/kebulanlalu': 'Ke Periode Lalu',
    '/transferusp': 'Transfer USP',
    '/transferangsuran': 'Transfer Angsuran',
    '/transfermanasuka': 'Transfer Manasuka',
    '/transferhariraya': 'Transfer Hari Raya',
    '/laporanneraca': 'Laporan Neraca',
    '/tutupakuntansi': 'Tutup Akuntansi',
    '/reprosesjurnal': 'Reproses Jurnal',
    '/daftarjurnal': 'Daftar Jurnal',
  };

  const pageTitle = pageTitles[currentPath] || 'Dashboard';

  // ==============================
  // BREADCRUMB PER HALAMAN
  // ==============================
  const pageBreadcrumbs = {
    '/dashboard': [{ name: 'Home', to: '/dashboard' }, { name: 'Dashboard', to: '/dashboard' }],
    '/dashboard2': [{ name: 'Home', to: '/dashboard' }, { name: 'Dashboard', to: '/dashboard2' }],

    '/role': [{ name: 'Setup', to: '/#' }, { name: 'Role', to: '/role' }],
    '/rolehalaman': [{ name: 'Setup', to: '/#' }, { name: 'Role Halaman', to: '/rolehalaman' }],
    '/daftaruser': [{ name: 'Setup', to: '/#' }, { name: 'User', to: '/daftaruser' }],
    '/daftaranggota': [{ name: 'Setup', to: '/#' }, { name: 'Anggota', to: '/daftaranggota' }],
    '/daftarunitkerja': [{ name: 'Setup', to: '/#' }, { name: 'Unit Kerja', to: '/daftarunitkerja' }],
    '/settingsimpanan': [{ name: 'Setup', to: '/#' }, { name: 'Simpanan', to: '/settingsimpanan' }],
    '/setjasapinjaman': [{ name: 'Setup', to: '/#' }, { name: 'Setting Jasa Pinjaman', to: '/setjasapinjaman' }],
    '/setjasamanasuka': [{ name: 'Setup', to: '/#' }, { name: 'Setting Jasa Manasuka', to: '/setjasamanasuka' }],
    '/perkiraan': [{ name: 'Setup', to: '/#' }, { name: 'Perkiraan', to: '/perkiraan' }],
    '/potsimpmanasuka': [{ name: 'Setup', to: '/#' }, { name: 'Potongan Simpanan Manasuka', to: '/potsimpmanasuka' }],

    '/simpanangsurusp2': [{ name: 'Transaksi', to: '/#' }, { name: 'Simpanan Angsuran Umum', to: '/simpanangsurusp2' }],
    '/transaksimanasuka': [{ name: 'Transaksi', to: '/#' }, { name: 'Transaksi Manasuka', to: '/transaksimanasuka' }],
    '/transaksihariraya': [{ name: 'Transaksi', to: '/#' }, { name: 'Transaksi Hari Raya', to: '/transaksihariraya' }],
    '/transaksirealisasi': [{ name: 'Transaksi', to: '/#' }, { name: 'Realisasi', to: '/transaksirealisasi' }],

    '/laporanharian1': [{ name: 'Laporan Harian', to: '/#' }, { name: 'Simpanan USP', to: '/laporanharian1' }],
    '/laporanharianmanasuka': [{ name: 'Laporan Harian', to: '/#' }, { name: 'Simpanan Manasuka', to: '/laporanharianmanasuka' }],
    '/laporanharianhariraya': [{ name: 'Laporan Harian', to: '/#' }, { name: 'Simpanan Hari Raya', to: '/laporanharianhariraya' }],
    '/laporanvoucherbelanja': [{ name: 'Laporan Harian', to: '/#' }, { name: 'Simpanan Voucher Belanja', to: '/laporanvoucherbelanja' }],
    '/laporanharianangsuran': [{ name: 'Laporan Harian', to: '/#' }, { name: 'Angsuran', to: '/laporanharianangsuran' }],
    '/laporanharianangsuran2': [{ name: 'Laporan Harian', to: '/#' }, { name: 'Angsuran2', to: '/laporanharianangsuran2' }],
    '/realisasipinjaman': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Realisasi Pinjaman', to: '/realisasipinjaman' }],

    '/laporanmutasisimpananusp': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Simpanan USP', to: '/laporanmutasisimpananusp' }],
    '/laporanmutasisimpmanasuka': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Simpanan Manasuka', to: '/laporanmutasisimpmanasuka' }],
    '/laporanmutasisimphariraya': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Simpanan Hari Raya', to: '/laporanmutasisimphariraya' }],
    '/laporanmutasivoucher': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Simpanan Voucher', to: '/laporanmutasivoucher' }],
    '/laporanmutasiangsuran': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Angsuran', to: '/laporanmutasiangsuran' }],
    '/mutasipotongan': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Potongan', to: '/mutasipotongan' }],
    '/mutasitunggakan': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Tunggakan', to: '/mutasitunggakan' }],
    '/mutasirealisasi': [{ name: 'Laporan Bulanan', to: '/#' }, { name: 'Realisasi', to: '/mutasirealisasi' }],

    '/prosesmanasuka': [{ name: 'Proses', to: '/#' }, { name: 'Jasa Manasuka', to: '/prosesmanasuka' }],
    '/proseshariraya': [{ name: 'Proses', to: '/#' }, { name: 'Jasa Hariraya', to: '/proseshariraya' }],
    '/prosespotongan': [{ name: 'Proses', to: '/#' }, { name: 'Potongan', to: '/prosespotongan' }],
    '/potongan': [{ name: 'Proses', to: '/#' }, { name: 'Potongan', to: '/potongan' }],
    '/tutupbulan': [{ name: 'Proses', to: '/#' }, { name: 'Tutup Bulan', to: '/tutupbulan' }],
    '/daftarsimpmanasuka': [{ name: 'Proses', to: '/#' }, { name: 'Simpanan Manasuka', to: '/daftarsimpmanasuka' }],
    '/daftarsimpsaham': [{ name: 'Proses', to: '/#' }, { name: 'Simpanan Saham', to: '/daftarsimpsaham' }],

    '/jurnal': [{ name: 'Akuntansi', to: '/#' }, { name: 'Entri Jurnal', to: '/jurnal' }],
    '/laporanjurnal': [{ name: 'Akuntansi', to: '/#' }, { name: 'Laporan Jurnal', to: '/laporanjurnal' }],
    '/lapbukubesar': [{ name: 'Akuntansi', to: '/#' }, { name: 'Laporan Buku Besar', to: '/lapbukubesar' }],
    '/rugilaba': [{ name: 'Akuntansi', to: '/#' }, { name: 'Rugi Laba', to: '/rugilaba' }],
    '/daftarangsuran': [{ name: 'Akuntansi', to: '/#' }, { name: 'Daftar Angsuran', to: '/daftarangsuran' }],
    '/transferusp': [{ name: 'Akuntansi', to: '/#' }, { name: 'Transfer USP', to: '/transferusp' }],
    '/transferangsuran': [{ name: 'Akuntansi', to: '/#' }, { name: 'Transfer Angsuran', to: '/transferangsuran' }],
    '/transfermanasuka': [{ name: 'Akuntansi', to: '/#' }, { name: 'Transfer Manasuka', to: '/transfermanasuka' }],
    '/transferhariraya': [{ name: 'Akuntansi', to: '/#' }, { name: 'Transfer Hari Raya', to: '/transferhariraya' }],
    '/laporanneraca': [{ name: 'Akuntansi', to: '/#' }, { name: 'Laporan Neraca', to: '/laporanneraca' }],
    '/tutupakuntansi': [{ name: 'Akuntansi', to: '/#' }, { name: 'Tutup Akuntansi', to: '/tutupakuntansi' }],
    '/reprosesjurnal': [{ name: 'Akuntansi', to: '/#' }, { name: 'Reproses Jurnal', to: '/reprosesjurnal' }],
    '/daftarjurnal': [{ name: 'Akuntansi', to: '/#' }, { name: 'Daftar Jurnal', to: '/daftarjurnal' }],
    '/kebulanlalu': [{ name: 'Akuntansi', to: '/#' }, { name: 'Ke Bulan Sebelumnya', to: '/kebulanlalu' }],
  };

  const pageCrumbs = pageBreadcrumbs[currentPath] || [{ name: 'Home', to: '/dashboard' }, { name: pageTitle, to: location.pathname }];

  return (
    <div
      className="wrapper"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header />
      <Menu />
      <div
        className="content-wrapper"
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "1rem",
          background: "#f4f6f9",
        }}
      >
        <Contens title={pageTitle} crumbs={pageCrumbs} />

      </div>

      <Footer />
    </div>
  );

}

export default ProtectedLayout;